<style scoped>
.email-alert {
  margin-left: 15px;
  margin-right: 15px;
}
</style>
<template>
  <b-modal
    :id="id"
    ref="modal"
    title="Account Recovery"
    header-class="anchor-modal"
    hide-footer
    no-close-on-backdrop
    static
  >
      <h4 slot="title" class="sr-only"> Account Recovery </h4>
      <b-alert show variant="primary" class="email-alert mt-2">
        Your account has been locked due to an excessive number
        of unsuccessful sign in attempts.<br>
        An email has been automatically sent to unlock your
        account. If you don't see a new email please wait a few
        minutes and also check your junk/spam folder just in case.
      </b-alert>
      <vue-form-generator
        :schema="form.schema"
        :model="model"
        :options="form.options"
        ref="emailForm"
      />
      <b-row>
        <b-col class="text-center mr-3">
          <b-button
            class="btn-anchor raised"
            id="resend-button"
            ref="resendButton"
            @click="submit"
          >
            Resend email
          </b-button>
        </b-col>
      </b-row>
  </b-modal>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard';
import VueFormGenerator from 'vue-form-generator';

import helper from '@/libs/helper';

import MODEL from '@/components/auth/unlock_account/resources/model.json';
import SCHEMA from '@/components/auth/unlock_account/resources/schema';


export default {
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    'vue-form-generator': VueFormGenerator.component,
  },
  data() {
    return {
      id: 'resend-unlock-link-modal',
      model: null,
      form: SCHEMA,
    };
  },
  methods: {
    resetModel() {
      this.model = helper.copy(MODEL);
    },
    show() {
      const modal = this.$refs.modal;
      this.resetModel();
      if (modal) {
        modal.show();
      }
    },
    hide() {
      const modal = this.$refs.modal;
      this.resetModel();
      if (modal) {
        modal.hide();
      }
    },
    sendLink() {
      this.$reqs.post('/resend_unlock_link', { user_email: this.model.email })
        .then((response) => {
          this.$notify({
            group: 'alert',
            text: response.data.message,
            type: 'success',
            duration: 3000,
            closeOnClick: true,
          });
          this.$emit('email-sent');
          this.hide();
        })
        .catch(() => {});
    },
    submit() {
      if (!this.$refs.emailForm.validate()) { return; }
      this.sendLink();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/unlock_account/ResendUnlockLink.vue